import axios from 'axios';
import { applyJwtInterceptor } from '@webapp-next/lib/request/utils/jwt';
import applyCsrfInterceptor from '@webapp-next/lib/request/utils/apply-csrf-interceptor';
import { getWindow } from '@/lib/app';

const http = axios.create();
applyCsrfInterceptor(http);

const localWindow = getWindow();

if (!localWindow.Cypress) {
  applyJwtInterceptor(http, {
    aud: 'DEPUTY',
    baseUrl: '/api/v1',
    claims: {
      deputy_user_id: '',
      deputy_business_id: '',
      deputy_employee_profile_id: '',
      deputy_business_user_id: '',
      deputy_business_location_id: '',
    },
  });
}

export const post = http.post;

export const put = http.put;

export const patch = http.patch;

export const remove = http.delete;

export const get = http.get;
// TODO: I simplified because of code repetition and next step is to remove this unnecessary alias on the http client
export const list = get;
/**
 * @type {AxiosInstance}
 */
export default http;
